// Mehrsegment-Ring („Donut") — reiner SVG-Renderer für die von `splitRing.ts`
// berechneten Bögen. Nur Rand, keine Füllung, wie ein Lade-Spinner.
//
// Die Datei heißt NICHT `SplitRing.tsx`: Dateinamen sind auf macOS
// case-insensitiv, `./SplitRing` würde also auf `splitRing.ts` zeigen (TS1149,
// `forceConsistentCasingInFileNames`). Die Komponente selbst heißt `SplitRing`.

import * as React from "react";
import { RING_SIZE, RING_STROKE } from "./splitRing";
import type { RingArc } from "./splitRing";

const RADIUS = (RING_SIZE - RING_STROKE) / 2;
const MITTE = RING_SIZE / 2;
/** Dezente Spur unter den Segmenten — gibt dem Ring auch bei dünnen Bögen Form. */
const TRACK = "rgba(45,20,43,0.10)";

/**
 * Zeichnet die Segmente eines aggregierten Betrags.
 *
 * `aria-hidden`, weil die Semantik im umgebenden Button sitzt (dessen
 * `aria-label` nennt Kennzahl, Jahr und Firmenzahl); ein zweites Mal vorgelesen
 * wäre der Ring nur Lärm.
 */
export const SplitRing: React.FC<{ arcs: RingArc[] }> = ({ arcs }) => (
  <svg
    width={RING_SIZE}
    height={RING_SIZE}
    viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
    aria-hidden="true"
    focusable="false"
    style={{ transform: "rotate(-90deg)", display: "block" }}
  >
    <circle cx={MITTE} cy={MITTE} r={RADIUS} stroke={TRACK} strokeWidth={RING_STROKE} fill="none" />
    {arcs.map((a, i) => (
      <circle
        key={i}
        cx={MITTE}
        cy={MITTE}
        r={RADIUS}
        stroke={a.color}
        strokeWidth={RING_STROKE}
        fill="none"
        strokeDasharray={a.dashArray}
        strokeDashoffset={a.dashOffset}
        style={{ transition: "stroke-dashoffset 240ms ease, stroke-dasharray 240ms ease" }}
      />
    ))}
  </svg>
);

export default SplitRing;
